import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, Icon, Switch, InputItem, Toast } from 'antd-mobile';
import { merge, get, clone, set, findIndex } from 'lodash';
import { TextDialog } from '../../../components/textDialog';
import { PlayButton } from '../../../components/icons/playButton';
import { HeaderImages } from '../../../components/copyright/headerImages';
import { BackBtn } from '../../../components/icons/back';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { Vh5Bar } from '../../../components/bar';
import { reAuth } from '../../../utils/weixin';
import { _track } from '../../../utils/track';
import { getQueryString, isVideoUrl, readCookie } from '../../../utils/common';
import { getCopyrightUserInfo } from '../../commonAction';
import { getImgInfo } from '../idetail/action';
import { getListBySectionId } from './/action';
import { handleImgData } from '../activityList/action';
import { Vh5Video } from '../../../components/videoPaler';
import { ShareTip } from '../../../components/copyright/shareTip';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { CommonFooter } from '../../../components/copyright/commonFooter';
import LazyLoad from 'vanilla-lazyload';
import './index.scss';
let lazyLoadInstance = null;
// const mapStateToProps = state => {
// 	return {
// 		siteSwitch: state.AdminReducers.siteSwitch
// 	};
// };

let contentId = getQueryString('contentId');
let sectionId = getQueryString('sectionId');
let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
function CopyrightSharedPage() {
	let history = useHistory();
	let [playerOptions, setPlayerOptions] = useState({});
	let dispatch = useDispatch();
	const [pageData, setPageData] = useState({
		isShowShareTip: false,
		isDispatched: false,
		video: {
			key: '',
			thumbKey: '',
			width: 0,
			height: 0,
			duration: 0
		},
		images: {
			topicContents: []
		},
		info: {
			avatar: '',
			nickname: '',
			sectionDescription: '', // 组描述
			des: '' // 只有一张照片是显示单图描述
		}
	});

	useEffect(() => {
		function getByContentId(contentId) {
			if (pageData.isDispatched) {
				return;
			}
			// let key = isVideoUrl(data.key) ? data.thumbKey : data.key;
			dispatch(
				getImgInfo({ contentId }, data => {
					pageData.info.avatar = data.avatar;
					pageData.info.nickname = data.authorUserName;
					pageData.info.des = data.sectionDescription;
					pageData.info.sectionDescription = data.description;
					pageData.images.topicContents = [data];
					pageData.isDispatched = true;
					setPageData({ ...pageData });
				})
			);
		}
		function getBySectionId(sectionId) {
			if (pageData.isDispatched) {
				lazyLoadInstance.update();
				return;
			}
			dispatch(
				getListBySectionId({ sectionId, userId }, data => {
					let firstItem = data.topicContentResponses[0];
					let { avatar, nickname, key } = firstItem;
					pageData.info.avatar = avatar;
					pageData.info.nickname = nickname;
					pageData.info.sectionDescription = data.description;
					if (data.topicContentResponses.length === 1) {
						pageData.info.des = data.topicContentResponses[0].description;
					}
					if (isVideoUrl(key)) {
						pageData.video.key = firstItem.key;
						pageData.video.thumbKey = firstItem.thumbUrl || firstItem.thumbKey;
						pageData.video.width = firstItem.width;
						pageData.video.height = firstItem.height;
						pageData.video.duration = firstItem.duration;
					} else {
						pageData.images.topicContents = data.topicContentResponses;
					}
					pageData.isDispatched = true;
					setPageData({ ...pageData });
					lazyLoadInstance.update();
				})
			);
		}
		if (contentId) {
			getByContentId(contentId);
		} else if (sectionId) {
			getBySectionId(sectionId);
		}
		dispatch(
			getWeixinConfig({ url: window.location.href }, data => {
				console.log('getWeixinConfig', data);
				configWeixin(data, {
					title: '投图',
					desc: '主题影像即时创作平台'
				});
			})
		);
		lazyLoadInstance = new LazyLoad({
			elements_selector: '.lazy',
			load_delay: 200
			// ... more custom settings?
		});
	}, [dispatch, pageData, setPageData]);

	function calcHeight(video) {
		let winWidth = window.innerWidth;
		return (video.height * winWidth) / video.width;
	}

	function handleClickVideo(item) {
		onPlayer({
			url: item.key,
			type: ''
		});
	}

	function onPlayer({ url, type }) {
		const videoJsOptions = {
			autoplay: true,
			controls: true,
			fluid: true,
			controlBar: {
				fullscreenToggle: false
			},
			sources: [
				{
					src: url,
					type: type || 'video/mp4'
				}
			],
			closeCallback: () => {
				setPlayerOptions({});
			}
		};
		setPlayerOptions(videoJsOptions);
	}

	function VideoBox(props) {
		let video = pageData.video;
		let { key, thumbKey, duration } = video;
		return (
			<div className="video-box" style={{ height: calcHeight(video), backgroundImage: `url(${thumbKey})` }}>
				<PlayButton
					duration={duration}
					onClick={() => {
						handleClickVideo(video);
					}}
				/>
			</div>
		);
	}

	function handleClickShareBtn() {
		pageData.isShowShareTip = true;
		setPageData({ ...pageData });
	}
	function handleClickShareTip() {
		pageData.isShowShareTip = false;
		setPageData({ ...pageData });
	}

	function onToidetail(index) {
		// let { topicContents, sectionDescription } = album;
		let topicContents = pageData.images.topicContents;
		let sectionDescription = pageData.info.sectionDescription;
		let defaultProps = handleImgData(topicContents);
		let item = topicContents[index];

		let objectProps = clone(defaultProps);
		let newItems = objectProps.items.filter(item => {
			return true;
		});

		objectProps.items = newItems;
		let matchIndex = findIndex(newItems, ['id', item.id]);
		history.push({
			pathname: '/vpmobile/copyright/idetail',
			state: {
				defaultProps: objectProps,
				index: matchIndex,
				sectionDescription
			}
		});
	}

	function Images(props) {
		let { toIdeital } = props;
		let items = props.items;
		return items.map((item, index) => {
			return (
				<li
					key={items.length === 1 ? item.key : item.thumbKey}
					onClick={() => {
						toIdeital(index);
					}}>
					<picture>
						<img className="lazy" alt="" src={item.key} />
					</picture>
				</li>
			);
		});
	}

	function Info(props) {
		let { avatar, nickname, sectionDescription, des } = props.info;
		if (!avatar) {
			avatar = 'https://gallerytemplate.vphotos.cn/copyright/default-avatar.jpg';
		}
		return (
			<div className="shared-page-info">
				<div className="person-info">
					<div className="person">
						<img className="avatar" src={avatar} alt="" />
						<span className="nickname">{nickname}</span>
					</div>
					<div className="share" onClick={handleClickShareBtn}>
						<i className="iconfont">&#xe657;</i>
						<span className="text">分享</span>
					</div>
				</div>
				{sectionDescription ? <p className="sectionDescription">{sectionDescription}</p> : ''}
				{des ? <p className="des">{des}</p> : ''}
			</div>
		);
	}

	function wrapperClass() {
		let str = 'copyright copyright-shared-page';
		if (pageData.video.key) {
			str += ' video';
		}
		return str;
	}

	function handleClickBack() {
		history.push({
			pathname: '/vpmobile/copyright/home'
		});
	}

	function Header() {
		return (
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							window.location.href = '/vpmobile/copyright/home/';
						}}>
						返回首页
					</label>
				</div>
			</header>
		);
	}

	function imgagesClass(size) {
		if (size === 1) {
			return 'shared-images single';
		} else if (size === 2) {
			return 'shared-images double';
		}
		return 'shared-images';
	}

	return (
		<div className={wrapperClass()}>
			{/* <BackBtn className="back-btn" onClick={handleClickBack} color="#000" text="返回" /> */}
			<Header />
			{pageData.video.key ? (
				<VideoBox />
			) : (
				<ul className={imgagesClass(pageData.images.topicContents.length)}>
					<Images items={pageData.images.topicContents} toIdeital={onToidetail} />
				</ul>
			)}
			<Info info={pageData.info} />
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
			{pageData.isShowShareTip ? <ShareTip onClick={handleClickShareTip} /> : ''}
			<div className="footer-wrap">
				<div className="footer-slogan">
					<img alt="" width="408" height="165" className="lazy" data-src="https://gallerytemplate.vphotos.cn/copyright/20200226/footer-logo.png" />
				</div>
				<CommonFooter />
			</div>
		</div>
	);
}
export { CopyrightSharedPage };
